<template lang="pug">
.filter
  form(@submit.prevent="onFilter")
    modal(:active="true", title="Filtrar mensagens enviadas", @close="close")
      div(slot="modal-body")
        .form-group
          label.form-radio.form-inline
            input(
              type="radio",
              name="arquivada",
              v-model="q.arquivada_remetente_eq",
              :value="false"
            )
            i.form-icon
            span
              i.fa.fa-paper-plane
              |
              | Caixa de enviadas
          label.form-radio.form-inline
            input(
              type="radio",
              name="arquivada",
              v-model="q.arquivada_remetente_eq",
              :value="true"
            )
            i.form-icon
            span
              i.fa.fa-archive
              |
              | Enviadas arquivadas
        .columns
          .column.col-12.pb-1 Período
          .column.col-6
            datepicker(v-model="q.enviado_em_gteq", placeholder="De")
          .column.col-6
            datepicker(v-model="q.enviado_em_lteq", placeholder="Até")
      .float-right(slot="modal-footer")
        a.btn.btn-link.btn-lg.text-gray(
          @click="clearFilter({ arquivada_remetente_eq: false })",
          v-if="filtered"
        ) Limpar filtros
        button.btn.btn-primary.btn-lg Filtrar
</template>

<script>
import filterMixin, { defaultStoreImports } from "@/mixins/filter";
import Datepicker from "@/components/inputs/Datepicker";
import FormGroup from "@/components/helpers/FormGroup";

export default {
  components: { FormGroup, Datepicker },
  vuex: { "mensagens/enviadas": defaultStoreImports },
  mixins: [filterMixin],
  data() {
    return { q: { arquivada_remetente_eq: false } };
  },
  methods: {
    close() {
      this.$router.back();
    },
  },
};
</script>
